<template>
  <div
    class="etapa-formulario__campo etapa-formulario__campo--md-12 etapa-formulario__campo--xl-12"
  >
    <div
      class="validacao-finalizacao"
      :class="
        pendencias.length
          ? 'validacao-finalizacao--pendente'
          : 'validacao-finalizacao--completa'
      "
      role="status"
      aria-live="polite"
    >
      <div class="validacao-finalizacao__resumo">
        <i
          class="mdi validacao-finalizacao__icone"
          :class="
            pendencias.length
              ? 'mdi-alert-circle-outline'
              : 'mdi-check-circle-outline'
          "
          aria-hidden="true"
        ></i>
        <div class="validacao-finalizacao__texto">
          <strong class="validacao-finalizacao__titulo">
            {{
              pendencias.length
                ? "Ainda há itens para finalizar"
                : "Ocorrência completa!"
            }}
          </strong>
          <p v-if="pendencias.length" class="mb-0">
            Resolva as pendências listadas abaixo para concluir a ocorrência.
          </p>
          <p v-else class="mb-0">
            Todas as etapas estão preenchidas. Revise os dados antes de
            finalizar.
          </p>
        </div>
        <span class="validacao-finalizacao__contador">
          {{ pendencias.length }}
          {{ pendencias.length === 1 ? "pendência" : "pendências" }}
        </span>
      </div>

      <div class="validacao-finalizacao__progresso">
        <div class="validacao-finalizacao__progresso-cabecalho">
          <span>Etapas concluídas</span>
          <strong>{{ etapasConcluidas }} de {{ etapasTotal }}</strong>
        </div>
        <b-progress
          :max="etapasTotal"
          class="validacao-finalizacao__barra mb-0"
          height="1rem"
        >
          <b-progress-bar
            :value="etapasConcluidas"
            :variant="varianteProgresso"
            class="font-weight-bold text-white"
            animated
          >
            {{ progresso }}%
          </b-progress-bar>
          <span v-if="progresso === 0" class="validacao-finalizacao__zero">
            0%
          </span>
        </b-progress>
      </div>

      <ul v-if="pendencias.length" class="validacao-finalizacao__lista">
        <li
          v-for="(pendencia, indice) in pendencias"
          :key="`${pendencia.aba}-${pendencia.campo}-${indice}`"
          class="validacao-finalizacao__item"
        >
          <span class="validacao-finalizacao__aba">{{ pendencia.aba }}:</span>
          {{ pendencia.mensagem }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="js">
const ETAPAS_FINALIZACAO = [
  "Dados da Ocorrência",
  "Estado de Saúde",
  "Envolvimento de Terceiros",
  "Anexos",
  "Validação da Ocorrência"
];

export default {
  name: "PendenciasFinalizacao",

  props: {
    pendencias: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    etapasTotal() {
      return ETAPAS_FINALIZACAO.length;
    },

    etapasConcluidas() {
      const etapasPendentes = new Set(
        this.pendencias.map(pendencia => pendencia.aba)
      );
      return ETAPAS_FINALIZACAO.filter(
        etapa => !etapasPendentes.has(etapa)
      ).length;
    },

    progresso() {
      return Math.round((this.etapasConcluidas / this.etapasTotal) * 100);
    },

    varianteProgresso() {
      if (this.progresso <= 30) return "danger";
      if (this.progresso <= 70) return "warning";
      if (this.progresso < 100) return "primary";
      return "success";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/_main";
@import "../../styles/components/_validacao-ocorrencia";
</style>


